









import { createComponent } from "@vue/composition-api";
import { RevisionItem } from "@megarax/client/src/resources/RevisionItem";

interface Props {
  value: RevisionItem;
}
export default createComponent<Props>({
  components: {},
  props: {
    value: { required: true },
  },
  setup(props, ctx) {
    return {};
  },
});
